import React from 'react';

export class AsdSearchResultStamps extends React.Component {

    render(stamps) {

        var stamps = this.props.stamps;

        if (stamps != undefined && Array.isArray(stamps)) {
            return (
                <div class="stamps">
                    {
                        stamps?.map((stamp) => {
                            return (
                                <div class={"stamp stamp-" + stamp.value.toLowerCase()}>{stamp.text}</div>
                            );
                        })
                    }
                </div>
            )
        }

    }

}
